import React from 'react';
import Topbar from '../components/Topbar';

const ArquitecturaDB = () => {
  return (
    <div className="flex-1 overflow-y-auto bg-[#0d0f14]">
      <Topbar
        title="Arquitectura DB"
        breadcrumb="Visionweb / Sistema / Arquitectura DB"
      />

      <div className="p-6 space-y-6">
        <div className="bg-[#13161e] border border-[#2a2e3d] rounded-md p-6">
          <p className="text-[#8b949e] font-['Mulish'] text-sm mb-6">
            Esta aplicación utiliza MongoDB como base de datos NoSQL para almacenar toda la información de clientes, productos/servicios y dominios. A continuación se muestra el esquema de datos y las relaciones entre colecciones.
          </p>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Módulo Clientes */}
            <div className="bg-[#0d0f14] border border-[#2a2e3d] rounded-md p-6">
              <h3 className="text-white font-['Fraunces'] text-xl font-bold mb-4">Módulo Clientes</h3>
              
              <div className="space-y-4">
                <div className="border border-[#2a2e3d] rounded-sm overflow-hidden">
                  <div className="bg-[#4f9eff]/10 border-b border-[#2a2e3d] px-4 py-2">
                    <div className="text-[#4f9eff] font-['IBM_Plex_Mono'] text-sm font-bold">clientes</div>
                  </div>
                  <div className="p-4 space-y-2">
                    {[
                      { field: 'id', type: 'String', note: 'PK' },
                      { field: 'nombre', type: 'String', note: '' },
                      { field: 'contacto', type: 'String', note: '' },
                      { field: 'email', type: 'String', note: 'UNIQUE' },
                      { field: 'telefono', type: 'String', note: '' },
                      { field: 'rfc', type: 'String', note: '' },
                      { field: 'dominio_principal', type: 'String', note: '' },
                      { field: 'direccion', type: 'String', note: '' },
                      { field: 'fecha_inicio', type: 'String', note: '' },
                      { field: 'estado', type: 'String', note: '' },
                      { field: 'servicios', type: 'Array', note: '' },
                      { field: 'created_at', type: 'DateTime', note: '' }
                    ].map((item, idx) => (
                      <div key={idx} className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <span className="text-white font-['IBM_Plex_Mono'] text-xs">{item.field}</span>
                          {item.note && (
                            <span className="text-[#4f9eff] font-['IBM_Plex_Mono'] text-xs bg-[#4f9eff]/10 px-1 rounded">{item.note}</span>
                          )}
                        </div>
                        <span className="text-[#8b949e] font-['IBM_Plex_Mono'] text-xs">{item.type}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Módulo Productos */}
            <div className="bg-[#0d0f14] border border-[#2a2e3d] rounded-md p-6">
              <h3 className="text-white font-['Fraunces'] text-xl font-bold mb-4">Módulo Productos/Servicios</h3>
              
              <div className="border border-[#2a2e3d] rounded-sm overflow-hidden">
                <div className="bg-[#00d68f]/10 border-b border-[#2a2e3d] px-4 py-2">
                  <div className="text-[#00d68f] font-['IBM_Plex_Mono'] text-sm font-bold">productos</div>
                </div>
                <div className="p-4 space-y-2">
                  {[
                    { field: 'id', type: 'String', note: 'PK' },
                    { field: 'nombre', type: 'String', note: '' },
                    { field: 'categoria', type: 'String', note: '' },
                    { field: 'tipo_producto', type: 'String', note: '' },
                    { field: 'tipo_servicio', type: 'String', note: '' },
                    { field: 'precio_base', type: 'Float', note: '' },
                    { field: 'periodicidad', type: 'String', note: '' },
                    { field: 'descripcion', type: 'String', note: '' },
                    { field: 'clientes_count', type: 'Integer', note: '' },
                    { field: 'created_at', type: 'DateTime', note: '' }
                  ].map((item, idx) => (
                    <div key={idx} className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <span className="text-white font-['IBM_Plex_Mono'] text-xs">{item.field}</span>
                        {item.note && (
                          <span className="text-[#00d68f] font-['IBM_Plex_Mono'] text-xs bg-[#00d68f]/10 px-1 rounded">{item.note}</span>
                        )}
                      </div>
                      <span className="text-[#8b949e] font-['IBM_Plex_Mono'] text-xs">{item.type}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Módulo Dominios */}
            <div className="bg-[#0d0f14] border border-[#2a2e3d] rounded-md p-6 lg:col-span-2">
              <h3 className="text-white font-['Fraunces'] text-xl font-bold mb-4">Módulo Dominios</h3>
              
              <div className="border border-[#2a2e3d] rounded-sm overflow-hidden">
                <div className="bg-[#ffc84a]/10 border-b border-[#2a2e3d] px-4 py-2">
                  <div className="text-[#ffc84a] font-['IBM_Plex_Mono'] text-sm font-bold">dominios</div>
                </div>
                <div className="p-4 grid grid-cols-2 gap-4">
                  <div className="space-y-2">
                    {[
                      { field: 'id', type: 'String', note: 'PK' },
                      { field: 'nombre', type: 'String', note: 'UNIQUE' },
                      { field: 'tipo', type: 'String', note: '' },
                      { field: 'registrar', type: 'String', note: '' },
                      { field: 'cliente_id', type: 'String', note: 'FK' },
                      { field: 'cliente_nombre', type: 'String', note: '' }
                    ].map((item, idx) => (
                      <div key={idx} className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <span className="text-white font-['IBM_Plex_Mono'] text-xs">{item.field}</span>
                          {item.note && (
                            <span className="text-[#ffc84a] font-['IBM_Plex_Mono'] text-xs bg-[#ffc84a]/10 px-1 rounded">{item.note}</span>
                          )}
                        </div>
                        <span className="text-[#8b949e] font-['IBM_Plex_Mono'] text-xs">{item.type}</span>
                      </div>
                    ))}
                  </div>
                  <div className="space-y-2">
                    {[
                      { field: 'anualidad', type: 'Float', note: '' },
                      { field: 'fecha_registro', type: 'String', note: '' },
                      { field: 'fecha_vencimiento', type: 'String', note: '' },
                      { field: 'auto_renovar', type: 'String', note: '' },
                      { field: 'estado', type: 'String', note: '' },
                      { field: 'created_at', type: 'DateTime', note: '' }
                    ].map((item, idx) => (
                      <div key={idx} className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <span className="text-white font-['IBM_Plex_Mono'] text-xs">{item.field}</span>
                          {item.note && (
                            <span className="text-[#ffc84a] font-['IBM_Plex_Mono'] text-xs bg-[#ffc84a]/10 px-1 rounded">{item.note}</span>
                          )}
                        </div>
                        <span className="text-[#8b949e] font-['IBM_Plex_Mono'] text-xs">{item.type}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArquitecturaDB;